import styled from 'styled-components';
import wixService from '../../../../../../services/wixService';

function getMobileQuestionNumberFontSize(settings) {
  return settings.isNewApp && wixService.isMobile()
    ? settings.mobile.questionsNumberFontSize + 'px !important'
    : '';
}

function getMobileQuestionTitleFontSize(settings) {
  return settings.isNewApp && wixService.isMobile()
    ? settings.mobile.questionsFontSize + 'px !important'
    : '';
}

function getQuestionNumberBG(stripColor) {
  try {
    if (typeof stripColor !== 'undefined' && stripColor !== '') {
      return wixService.getTinycolor(stripColor).setAlpha(0.1).toRgbString();
    }
  } catch (e) {
    console.log('e:', stripColor);
    return stripColor;
  }
}
function getQuestionHeaderBG(stripColor) {
  try {
    if (typeof stripColor !== 'undefined' && stripColor !== '') {
      return wixService.getTinycolor(stripColor).setAlpha(0.05).toRgbString();
    }
  } catch (e) {
    console.log('e:', stripColor);
    return stripColor;
  }
}
function getScrollBarBG(stripColor) {
  try {
    if (typeof stripColor !== 'undefined' && stripColor !== '') {
      return wixService.getTinycolor(stripColor).setAlpha(0.3).toRgbString();
    }
  } catch (e) {
    console.log('e:', stripColor);
    return stripColor;
  }
}

export const CusttomScrollBar = styled.div`
  &.fixedScrollbar::-webkit-scrollbar-thumb {
    background-color: ${(props) =>
      getScrollBarBG(
        wixService.getColorByreference(
          props.design.questionStripesText.color.value,
        ),
      )};
    background-color: ${(props) =>
      getScrollBarBG(
        wixService.getColorValueByComponentName(
          props.styleParams,
          props.design.questionStripesText.color.name,
        ),
      )};
  }
`;

export const MainItemContainer = styled.div``;

export const Header = styled.div`
  background-color: ${(props) =>
    getQuestionHeaderBG(
      wixService.getColorByreference(props.design.stripColor.color.value),
    )} !important;
  background-color: ${(props) =>
    getQuestionHeaderBG(
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.stripColor.color.name,
      ),
    )} !important;
`;

export const ItemNumber = styled.div`
  background-color: ${(props) =>
    getQuestionNumberBG(
      wixService.getColorByreference(props.design.stripColor.color.value),
    )} !important;
  background-color: ${(props) =>
    getQuestionNumberBG(
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.stripColor.color.name,
      ),
    )} !important;
  color: ${(props) =>
    wixService.getColorByreference(
      props.design.questionNumberText.color.value,
    )};
  color: ${(props) =>
    wixService.getColorValueByComponentName(
      props.styleParams,
      props.design.questionNumberText.color.name,
    )};

  ${(props) =>
    wixService.getStyleFontByReference(
      props.design.questionNumberText.font.value,
    )};
  font-size: ${(props) =>
    props.design.questionNumberText.font.startWithSize + 'px'};
  font: ${(props) =>
    wixService.getFontValueByComponentName(
      props.styleParams,
      props.design.questionNumberText.font.name,
    )};

  font-size: ${(props) => getMobileQuestionNumberFontSize(props.settings)};

  text-decoration: ${(props) =>
    wixService.getFontTextDecoration(
      props.styleParams,
      props.design.questionNumberText.font.name,
    )} !important;

  ${Header}:hover & {
    background-color: ${(props) =>
      wixService.getColorByreference(
        props.design.questionNumberHover.color.value,
      )} !important;
    background-color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.questionNumberHover.color.name,
      )} !important;
  }

  }
  ${MainItemContainer}.isopen & {
    background-color: ${(props) =>
      wixService.getColorByreference(
        props.design.questionNumberHover.color.value,
      )} !important;
    background-color: ${(props) =>
      wixService.getColorValueByComponentName(
        props.styleParams,
        props.design.questionNumberHover.color.name,
      )} !important;
  }
`;

export const ItemTitle = styled.div`
  color: ${(props) =>
    wixService.getColorByreference(
      props.design.questionStripesText.color.value,
    )};
  color: ${(props) =>
    wixService.getColorValueByComponentName(
      props.styleParams,
      props.design.questionStripesText.color.name,
    )};
  ${(props) =>
    wixService.getStyleFontByReference(
      props.design.questionStripesText.font.value,
    )};
  font-size: ${(props) =>
    props.design.questionStripesText.font.startWithSize + 'px'};
  font: ${(props) =>
    wixService.getFontValueByComponentName(
      props.styleParams,
      props.design.questionStripesText.font.name,
    )};
  font-size: ${(props) => getMobileQuestionTitleFontSize(props.settings)};
  text-decoration: ${(props) =>
    wixService.getFontTextDecoration(
      props.styleParams,
      props.design.questionStripesText.font.name,
    )} !important;

  button {
  }
`;
